import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'ticketing-faq-item',
  imports: [CommonModule, FaIconComponent],
  templateUrl: './faq-item.component.html',
  styleUrl: './faq-item.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqItemComponent {
  isOpen = signal<boolean>(false);
  question = input.required<string>();
  answer = input.required<string>();
  protected readonly faCaretDown = faCaretDown;

  toggle() {
    this.isOpen.set(!this.isOpen());
  }
}
